import { TagField } from "../../../components/others/TagField";
import { Practice } from "../../../services/TurnServices/Turns.type";

export type PracticesProps = {
  practices: Practice[];
  listContainerStyles?: string;
  listItemsStyles?: string;
  keyPrefix?: string;
};

export const PracticesList: React.FC<PracticesProps> = ({
  practices,
  listItemsStyles,
  listContainerStyles,
  keyPrefix,
}) => (
  <div className={`flex flex-wrap ${listContainerStyles}`}>
    {practices?.map((practice) => (
      <TagField
        key={`${keyPrefix || ""}${practice.id}`}
        className={`mr-4 ${listItemsStyles}`}
      >
        {practice.name}
      </TagField>
    ))}
  </div>
);
